export const MQ_SMALL = 480;
export const MQ_MEDIUM = 768;
export const MQ_LARGE = 1024;
